import { reportError } from 'conversations-error-reporting/error-reporting/reportError';
import http from 'conversations-http/clients/http';
import { registerMutation, useMutation } from 'data-fetching-client';
import { useCallback } from 'react';
const SET_AS_HOME_PAGE_VIEW = registerMutation({
  fetcher: ({
    workspaceId,
    viewId
  }) => http.post(`/conversations-custom-views/v1/settings/workspaces/${workspaceId}/defaultViews/${viewId}`),
  fieldName: 'setAsHomePageView'
});
export const useSetAsHomePageView = ({
  onSetHomePageView,
  workspaceId
}) => {
  const [_setHomePageView, {
    error,
    loading
  }] = useMutation(SET_AS_HOME_PAGE_VIEW);
  const setHomePageView = useCallback(({
    viewId,
    viewName,
    isDefaultCustomView
  }) => {
    if (!workspaceId) {
      return null;
    }
    onSetHomePageView === null || onSetHomePageView === void 0 || onSetHomePageView({
      isDefaultCustomView
    });
    return _setHomePageView({
      variables: {
        workspaceId,
        viewId
      }
    }).then(() => viewName).catch(err => {
      reportError({
        error: err
      });
      throw err;
    });
  }, [_setHomePageView, onSetHomePageView, workspaceId]);
  return {
    error,
    loading,
    setHomePageView
  };
};